import { PlacementType } from '../CreativeCard';
import { CreativeFilter, CreativeFilterType } from './types';

export const CreativeFilters: CreativeFilterType[] = [
  'all',
  'wideLandscape',
  'landscape',
  'square',
  'vertical',
];

export const WideLandscapeVariants: PlacementType[] = [
  'SuperLeaderboard',
  'Leaderboard',
  'FullBanner',
  'SmallLeaderboard',
  'Banner',
  'LargeBanner',
  'MediumBanner',
  'SmallBanner',
];

export const LandscapeVariants: PlacementType[] = [
  'HalfBanner',
  'Billboard',
  'LandscapeLargeBanner',
  'Landscape',
];

export const SquareVariants: PlacementType[] = [
  'LargeRectangle',
  'MediumRectangle',
  'Rectangle',
  'Square',
];

export const VerticalVariants: PlacementType[] = [
  'Portrait',
  'HalfPage',
  'WideSkyscraper',
  'Skyscraper',
];

export const CreativeFilterConfig: Record<CreativeFilterType, CreativeFilter> = {
  all: {
    type: 'all',
    label: _TL_('All'),
    predicate: () => true,
  },
  wideLandscape: {
    type: 'wideLandscape',
    label: _TL_('Wide Landscape'),
    predicate: (creative) => creative.placements.some((variant) => WideLandscapeVariants.includes(variant.type)),
  },
  landscape: {
    type: 'landscape',
    label: _TL_('Landscape'),
    predicate: (creative) => creative.placements.some((variant) => LandscapeVariants.includes(variant.type)),
  },
  square: {
    type: 'square',
    label: _TL_('Square'),
    predicate: (creative) => creative.placements.some((variant) => SquareVariants.includes(variant.type)),
  },
  vertical: {
    type: 'vertical',
    label: _TL_('Vertical'),
    predicate: (creative) => creative.placements.some((variant) => VerticalVariants.includes(variant.type)),
  },
};
